(function () {
  class MinMultiplierPopup extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      this._freeSpinsAwardedText = undefined;
      this._panel = undefined;
      this._darkOverlay = undefined;
      this._pressStartBox = undefined;
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      this._minMultiplierText = resourceManager.get(
        'minMultiplierPopupContainer:MinMultiplierPopup:panel:minMultiplierText'
      );
      this._minMultiplierGoldText = resourceManager.get(
        'minMultiplierPopupContainer:MinMultiplierPopup:panel:minMultiplierGoldText'
      );
      this._panel = resourceManager.get('minMultiplierPopupContainer:MinMultiplierPopup:panel');
      this._darkOverlay = resourceManager.get('minMultiplierPopupContainer:MinMultiplierPopup:darkOverlay');
      this._pressStartBox = resourceManager.get('minMultiplierPopupContainer:MinMultiplierPopup:pressStartColourBox');

      this._darkOverlay.interactive = true; // stop being able to click on anything behind the panel
      this._pressStartBox.interactive = false;
    }

    async show(multiplier = 2, allowSkip = false) {
      this.visible = true;
      this._pressStartBox.interactive = false;

      if (multiplier >= 20) {
        this._minMultiplierText.visible = false;
        this._minMultiplierGoldText.visible = true;
      } else {
        this._minMultiplierText.visible = true;
        this._minMultiplierGoldText.visible = false;
      }

      this._minMultiplierText.setText(`${multiplier}x`);
      this._minMultiplierGoldText.setText(`${multiplier}x`);

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          x: 1,
          y: 1,
          duration: 0.5,
          ease: 'bounce.out',
        }
      );

      // so the panel should auto disappear after 2 seconds
      // but also allow the player to press and make disappear quicker

      let waitForInteractionResolver = null;
      const waitForInteractionPromise = new Promise((resolve) => {
        waitForInteractionResolver = resolve;
      });

      this._pressStartBox.mousedown = this._pressStartBox.touchstart = () => {
        this._pressStartBox.interactive = false;
        waitForInteractionResolver();
      };

      if (allowSkip === true) {
        this._pressStartBox.interactive = true;
      }

      // now wait till 1 finishes
      await Promise.race([waitForInteractionPromise, timerManager.delayAsync(2000)]);

      this._pressStartBox.interactive = false;
      this._pressStartBox.mousedown = this._pressStartBox.touchstart = undefined;

      await game.tweenFromToAsync(
        this._panel.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0,
          y: 0,
          duration: 0.15,
          ease: 'none',
        }
      );

      this.visible = false;
    }
  }

  let create = function (json) {
    return new MinMultiplierPopup();
  };

  let initialise = function (json, container, resources) {
    container.initialise();
  };

  let getFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('MinMultiplierPopup', create, initialise, getFilesRequired);
})();
